<template>
  <div class="object-select-input clearfix">
    <div class="form-group">
      <label v-if="field.label" class="col-sm-4 control-label">{{ field.label }}<span v-if="field.required" class="required">*</span></label>
      <div :class="field.label ? 'col-sm-8' : 'col-sm-12'">
        <select class="form-control" :name="field.name" v-model="field.value" v-el:dropdown style="width:100%;">
          <option v-if="label" value="" disabled>Select a {{ label }}</option>
          <option v-for="object in field.objects" :value="object.uuid" :title="object[field.titleName]" :data-icon="object[field.iconName]" :description="object[field.description]">
            {{ object[field.objectName] }}
          </option>
        </select>
        <span class="form-validation-error"
        v-if="!field.valid && field.dirty">
        Please select a {{ label }}.</span>
        <span class="fa fa-check form-control-feedback
        form-control-feedback-success form-control-feedback-select"
        v-if="field.valid && field.dirty"></span>
        <span class="fa fa-remove form-control-feedback
        form-control-feedback-error form-control-feedback-select"
        v-if="!field.valid && field.dirty"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ObjectSelectInput',
  props: {
    field: {
      type: Object,
      default () {
        return {
          label: '',
          name: 'objectSelect',
          objectName: 'fullName',
          titleName: 'organizationName',
          value: '',
          objects: [],
          valid: false,
          dirty: false
        }
      }
    }
  },
  computed: {
    label () {
      return this.field.singleLabel
        ? this.field.singleLabel
        : this.field.label
    }
  },
  ready () {
    function template (data) {
      if (data.id) {
        if (data.element.attributes['data-icon']) {
          return $(`<span><span class="fa fa-cc-${data.element.attributes['data-icon'].value}"></span> ${data.text}</span>`)
        }
        if (data.element.attributes['description']) {
          return $(`<span><strong>${data.text}</strong><br/> <small>${data.element.attributes['description'].value}</small></span>`)
        }
      }
      if (data.title) {
        return data.text + data.title
      } else {
        return data.text
      }
    }
    function templateSelected (data) {
      if (data.id) {
        if (data.element.attributes['data-icon']) {
          return $(`<span><span class="fa fa-cc-${data.element.attributes['data-icon'].value}"></span> ${data.text}</span>`)
        }
      }
      return data.text
    }
    $(this.$els.dropdown).select2({
      templateResult: template,
      templateSelection: templateSelected,
      minimumResultsForSearch: 10
    })
    $(this.$els.dropdown).on('select2:select', e => {
      this.field.value = e.params.data.id
    })
    this.validate()
  },
  route: {
    data () {
      this.validate()
    }
  },
  watch: {
    'field.value': function (newVal, oldVal) {
      if (newVal !== oldVal) $(this.$els.dropdown).trigger('change.select2')
      this.validate()
    }
  },
  methods: {
    validate () {
      this.field.dirty = true
      this.field.valid = Boolean(this.field.value)
    }
  },
  events: {
    valueChanged () {
      $(this.$els.dropdown).trigger('change.select2')
    }
  }
}
</script>



// WEBPACK FOOTER //
// ObjectSelectInput.vue?026afb12